export class Order {
    $key?: string;
    offerId?: string;
    offerName?: string;
    type?: string;
    orderStatus?: string;
    date?: number;
    amount?: number;
    orderTime?: number;
    image?: string;
    code?: string;

    quantity?: number;
    club?: {
        name?: string;
        clubId?: string;
    }
    payment?: {
        paymentId?: string;
        amount?: number;
        paymentStatus?: string;

    }
    shippingAddress?: {
        userName?: string;
        address?: string;
        city?: string;
        state?: string;
        country?: string;
    }

}